(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-account-hub"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='da_fav_v1';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function esc(s){ return (''+(s||'')).replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];}); }

  var rail=document.querySelector('[data-da-acc-favrail]');
  var empty=document.querySelector('[data-da-acc-favempty]');
  var clearBtn=document.querySelector('[data-da-acc-favclear]');
  var counts=document.querySelectorAll('[data-da-acc-favcount],[data-da-acc-favcount2]');

  function setCounts(n){
    counts.forEach(function(el){
      if(el.hasAttribute('data-da-acc-favcount2')) el.textContent = n? '· '+n+(n===1?' guardado':' guardados') : '';
      else el.textContent = n;
    });
  }

  function quickAdd(handle, variantId, btn){
    if(!handle||!window.fetch) return;
    var orig=btn.textContent; btn.disabled=true; btn.textContent='Agregando…';
    function go(vid){
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){ btn.textContent='✓ Agregado'; setTimeout(function(){ window.location.href='/cart'; },450); })
        .catch(function(){ btn.disabled=false; btn.textContent=orig; window.location.href='/products/'+handle; });
    }
    if(variantId){ go(variantId); return; }
    fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
      if(p&&p.variants&&p.variants.length===1&&p.variants[0].available){ go(p.variants[0].id); }
      else { window.location.href='/products/'+handle; } // multi-variante o sin stock → PDP
    }).catch(function(){ window.location.href='/products/'+handle; });
  }

  function enrichFav(card, handle){
    if(!window.fetch||!handle) return;
    fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){
      if(!p) return;
      var v=(p.variants&&p.variants[0])||{};
      var price=(v.price!=null?v.price:p.price);
      var cmp=(v.compare_at_price!=null?v.compare_at_price:p.compare_at_price);
      var available=(p.variants||[]).some(function(x){return x.available;});
      var thumb=card.querySelector('.da-acc__favthumb');
      if(cmp&&price&&cmp>price&&thumb){
        var pct=Math.round((1-price/cmp)*100);
        var f=document.createElement('span'); f.className='da-acc__saleflag'; f.textContent='-'+pct+'%'; thumb.appendChild(f);
        var priceEl=card.querySelector('.da-acc__favprice');
        if(priceEl){ priceEl.innerHTML=money(price)+' <s class="da-acc__was">'+money(cmp)+'</s>'; }
      }
      if(!available){
        var addBtn=card.querySelector('.da-acc__add');
        if(addBtn){ addBtn.textContent='Sin stock'; addBtn.disabled=true; }
        if(thumb){ var o=document.createElement('span'); o.className='da-acc__oos'; o.textContent='Sin stock'; thumb.appendChild(o); }
      }
    }).catch(function(){});
  }

  function render(){
    if(!rail) return;
    var favs=read();
    setCounts(favs.length);
    rail.innerHTML='';
    if(!favs.length){ if(empty) empty.hidden=false; if(clearBtn) clearBtn.hidden=true; rail.hidden=true; return; }
    if(empty) empty.hidden=true; if(clearBtn) clearBtn.hidden=false; rail.hidden=false;
    favs.forEach(function(it){
      var card=document.createElement('div'); card.className='da-acc__favcard'; card.setAttribute('role','listitem');
      var img = it.image ? '<span class="da-acc__favthumb"><img src="'+esc(it.image)+'" alt="'+esc(it.title)+'" loading="lazy"></span>' : '<span class="da-acc__favthumb"></span>';
      card.innerHTML =
        '<button type="button" class="da-acc__favrm" aria-label="Quitar de favoritos">&times;</button>'+
        '<a class="da-acc__favlink" href="'+esc(it.url)+'" style="text-decoration:none;color:inherit;display:flex;flex-direction:column">'+
          img+
          '<span class="da-acc__favbody"><span class="da-acc__favname">'+esc(it.title)+'</span>'+
          (it.price?'<span class="da-acc__favprice">'+esc(it.price)+'</span>':'')+'</span>'+
        '</a>'+
        '<button type="button" class="da-acc__add">Agregar</button>';
      card.querySelector('.da-acc__favrm').addEventListener('click',function(){
        write(read().filter(function(x){return x.handle!==it.handle;}));
        render();
      });
      card.querySelector('.da-acc__add').addEventListener('click',function(){ quickAdd(it.handle,null,this); });
      rail.appendChild(card);
      enrichFav(card, it.handle);
    });
  }

  if(clearBtn) clearBtn.addEventListener('click',function(){ write([]); render(); });
  window.addEventListener('storage',function(e){ if(e.key===KEY) render(); });
  render();

  // ===== Vistos recientemente (clave compartida con sección PDP da-recently-viewed) =====
  var RVKEY='da_rv_v1';
  var rvBlock=document.querySelector('[data-da-acc-rvblock]');
  var rvRail=document.querySelector('[data-da-acc-rvrail]');
  function readRv(){ try{ return JSON.parse(localStorage.getItem(RVKEY)||'[]'); }catch(e){ return []; } }
  function renderRv(){
    if(!rvBlock||!rvRail) return;
    var list=readRv().slice(0,10);
    rvRail.innerHTML='';
    if(!list.length){ rvBlock.hidden=true; return; }
    rvBlock.hidden=false;
    list.forEach(function(it){
      var a=document.createElement('a'); a.className='da-acc__favcard'; a.href=it.url||'#'; a.setAttribute('role','listitem');
      var img=it.image?'<span class="da-acc__favthumb"><img src="'+esc(it.image)+'" alt="'+esc(it.title)+'" loading="lazy"></span>':'<span class="da-acc__favthumb"></span>';
      a.innerHTML=img+'<span class="da-acc__favbody"><span class="da-acc__favname">'+esc(it.title)+'</span>'+(it.price?'<span class="da-acc__favprice">'+esc(it.price)+'</span>':'')+'</span>';
      rvRail.appendChild(a);
    });
  }
  window.addEventListener('storage',function(e){ if(e.key===RVKEY) renderRv(); });
  renderRv();

  // ===== Elegidos para vos (Recommendations API de Shopify, sembrado con favorito/visto) =====
  var fyBlock=document.querySelector('[data-da-acc-foryou]');
  var fyRail=document.querySelector('[data-da-acc-foryou-rail]');
  var fyReason=document.querySelector('[data-da-acc-foryou-reason]');
  function money(cents){
    var n=Number(cents); if(!isFinite(n)) return '';
    if(n>=1000 && n%1===0) n=n/100; // .js devuelve centavos
    try{ return '$'+Math.round(n).toLocaleString('es-AR'); }catch(e){ return '$'+Math.round(n); }
  }
  function fyCard(p){
    var card=document.createElement('div'); card.className='da-acc__favcard'; card.setAttribute('role','listitem');
    var img=p.featured_image||(p.images&&p.images[0]&&(p.images[0].src||p.images[0]))||'';
    var imgHtml=img?'<span class="da-acc__favthumb"><img src="'+esc(img)+'" alt="'+esc(p.title)+'" loading="lazy"></span>':'<span class="da-acc__favthumb"></span>';
    var url=p.url||('/products/'+p.handle);
    card.innerHTML='<a class="da-acc__favlink" href="'+esc(url)+'" style="text-decoration:none;color:inherit;display:flex;flex-direction:column">'+imgHtml+'<span class="da-acc__favbody"><span class="da-acc__favname">'+esc(p.title)+'</span>'+(p.price!=null?'<span class="da-acc__favprice">'+money(p.price)+'</span>':'')+'</span></a>'+
      '<button type="button" class="da-acc__add">Agregar</button>';
    var vid=(p.variants&&p.variants.length===1&&p.variants[0].available)?p.variants[0].id:null;
    var handle=p.handle||((''+url).split('/products/')[1]||'').split(/[?#]/)[0];
    card.querySelector('.da-acc__add').addEventListener('click',function(){ quickAdd(handle,vid,this); });
    return card;
  }
  // normaliza un producto de /collections/*/products.json (precio string en $, imágenes {src}) a la forma de fyCard (precio en centavos, featured_image string)
  function normColl(p){
    var v=(p.variants&&p.variants[0])||{};
    return {
      handle:p.handle, title:p.title, url:'/products/'+p.handle,
      featured_image:(p.images&&p.images[0]&&(p.images[0].src||p.images[0]))||'',
      price: v.price!=null ? Math.round(parseFloat(v.price)*100) : null,
      variants:p.variants
    };
  }
  function fillFy(items, reason, normalize){
    if(!items.length) return false;
    fyRail.innerHTML='';
    items.forEach(function(p){ fyRail.appendChild(fyCard(normalize?normColl(p):p)); });
    if(fyReason) fyReason.textContent='· '+reason;
    fyBlock.hidden=false;
    return true;
  }
  function coldStart(){
    fetch('/collections/mas-vendidos/products.json?limit=10').then(function(r){return r.ok?r.json():null;}).then(function(d){
      fillFy((d&&d.products)||[], 'Lo más elegido', true);
    }).catch(function(){});
  }
  function loadForYou(){
    if(!fyBlock||!fyRail||!window.fetch) return;
    var seedFav=read()[0], seedRv=readRv()[0];
    var seed=seedFav||seedRv;
    if(!seed||!seed.handle){ coldStart(); return; } // arranque en frío: más vendidos
    var reason=seedFav?'Porque guardaste '+(seedFav.title||'un perfume'):'Porque viste '+(seedRv.title||'un perfume');
    fetch('/products/'+seed.handle+'.js').then(function(r){return r.ok?r.json():null;}).then(function(prod){
      if(!prod||!prod.id){ coldStart(); return; }
      return fetch('/recommendations/products.json?product_id='+prod.id+'&intent=related&limit=10')
        .then(function(r){return r.ok?r.json():null;}).then(function(d){
          var items=(d&&d.products)||[];
          if(!fillFy(items, reason, false)) coldStart();
        });
    }).catch(function(){ coldStart(); });
  }
  loadForYou();

  // ===== Búsquedas recientes (clave compartida con snippet da-recent-search) =====
  var SKEY='da_search_v1';
  var sBlock=document.querySelector('[data-da-acc-searches]');
  var sChips=document.querySelector('[data-da-acc-searchchips]');
  var sClear=document.querySelector('[data-da-acc-searchclear]');
  function readSearch(){ try{ return JSON.parse(localStorage.getItem(SKEY)||'[]'); }catch(e){ return []; } }
  function renderSearch(){
    if(!sBlock||!sChips) return;
    var list=readSearch();
    sChips.innerHTML='';
    if(!list.length){ sBlock.hidden=true; return; }
    sBlock.hidden=false;
    list.forEach(function(q){
      var a=document.createElement('a'); a.className='da-acc__chip'; a.setAttribute('role','listitem');
      a.href='/search?q='+encodeURIComponent(q)+'&type=product';
      a.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><span>'+esc(q)+'</span>';
      sChips.appendChild(a);
    });
  }
  if(sClear) sClear.addEventListener('click',function(){ try{localStorage.removeItem(SKEY);}catch(e){} renderSearch(); });
  window.addEventListener('da-search-changed',renderSearch);
  window.addEventListener('storage',function(e){ if(e.key===SKEY) renderSearch(); });
  renderSearch();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-bestsellers-3d"] && !Shopify.designMode) return;
  try {
    
// quick-add AJAX con feedback
document.addEventListener("submit",function(e){
  var f=e.target.closest("[data-da-add]"); if(!f) return;
  e.preventDefault();
  var btn=f.querySelector("button"), label=btn.querySelector("span"), old=label?label.textContent:"";
  fetch(f.action,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded","Accept":"application/json"},body:new URLSearchParams(new FormData(f))})
   .then(function(r){return r.json();})
   .then(function(){
     btn.classList.add("is-added"); if(label)label.textContent="¡Agregado!";
     document.dispatchEvent(new CustomEvent("cart:refresh"));
     if(window.Shopify&&Shopify.theme){}
     // intenta abrir el cart drawer del theme
     var t=document.querySelector("cart-drawer, #cart-drawer, [ref='cartDrawer']");
     setTimeout(function(){
       btn.classList.remove("is-added"); if(label)label.textContent=old;
       window.location.href="/cart";
     },900);
   })
   .catch(function(){ window.location.href="/cart"; });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-cart-extras"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(c){
    try{
      return new Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS',maximumFractionDigits:0}).format(c/100).replace(/\s/g,'');
    }catch(e){ return '$' + Math.round(c/100).toLocaleString('es-AR'); }
  }
  function render(root, total, count){
    var thr = parseInt(root.getAttribute('data-da-threshold'),10) || 5000000;
    var pct = total >= thr ? 100 : Math.min(98, Math.floor(total*100/thr));
    var bar = root.querySelector('[data-da-ship-bar]');
    var track = root.querySelector('[data-da-ship-track]');
    var msg = root.querySelector('[data-da-ship-msg]');
    if(bar) bar.style.width = pct + '%';
    if(track) track.classList.toggle('is-done', pct >= 100);
    var cuotasN = parseInt(root.getAttribute('data-da-installments'),10) || 3;
    var cuotaEl = root.querySelector('[data-da-cuota]');
    if(cuotaEl && cuotasN > 0) cuotaEl.textContent = money(Math.round(total/cuotasN));
    var stickyTotal = root.querySelector('[data-da-sticky-total]');
    if(stickyTotal) stickyTotal.textContent = money(total);
    var stickyShip = root.querySelector('[data-da-sticky-ship]');
    if(stickyShip){
      if(total >= thr){
        stickyShip.classList.add('is-win');
        stickyShip.textContent = '✓ Tenés envío gratis';
      }else{
        stickyShip.classList.remove('is-win');
        stickyShip.innerHTML = 'Sumá <b>' + money(thr - total) + '</b> → envío gratis';
      }
    }
    if(msg){
      if(total >= thr){
        msg.innerHTML = '<b class="da-cx__ship-win">¡Tenés envío gratis!</b>';
      }else if(pct >= 75){
        msg.innerHTML = '¡Te falta muy poco! Sumá <b>' + money(thr - total) + '</b> y tenés <b>envío gratis</b>';
      }else{
        msg.innerHTML = 'Te faltan <b>' + money(thr - total) + '</b> y te ahorrás <b>' + money(1350000) + '</b> de envío';
      }
    }
    if(typeof count === 'number'){
      var tm = root.querySelector('[data-da-tier-msg]');
      if(tm){
        var s;
        if(count>=10) s='\uD83C\uDF89 \u00a1Ten\u00e9s el m\u00e1ximo: 20% OFF!';
        else if(count>=7) s='\u00a110% OFF activo! Sum\u00e1 '+(10-count)+' y lleg\u00e1s a 20% OFF';
        else if(count>=5) s='\u00a15% OFF activo! Sum\u00e1 '+(7-count)+' y lleg\u00e1s a 10% OFF';
        else s='Sum\u00e1 '+(5-count)+' y obten\u00e9 5% OFF autom\u00e1tico';
        tm.textContent = s;
      }
    }
  }
  function refresh(){
    var roots = document.querySelectorAll('.da-cx[data-da-ship]');
    if(!roots.length){ roots = document.querySelectorAll('.da-cx'); }
    if(!roots.length) return;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ roots.forEach(function(root){ render(root, c.total_price, c.item_count); }); })
      .catch(function(){});
  }
  function boot(){
    refresh();
    // Re-sync cuando cambia el carrito (cambios de cantidad, eliminar item)
    document.addEventListener('cart:update', refresh); // evento real de Horizon (CartUpdateEvent, bubbles a document) — sincroniza al cambiar cantidad/eliminar
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);
    document.addEventListener('cart:change', refresh);
    document.body.addEventListener('click', function(e){
      var t = e.target.closest && e.target.closest('cart-items, .cart-item, [data-cart-item], quantity-selector');
      if(t) setTimeout(refresh, 700);
    });
    stickyAutoHide();
  }
  // Ocultar el sticky móvil cuando el botón "Finalizar compra" nativo ya está en pantalla:
  // evita el doble CTA redundante (sticky + nativo visibles a la vez) y reaparece al hacer scroll arriba.
  function stickyAutoHide(){
    var sticky = document.querySelector('.da-cx__sticky');
    var native = document.querySelector('#checkout, .cart__checkout-button');
    if(!sticky || !native || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ sticky.classList.toggle('is-hidden', en.isIntersecting); });
    }, {rootMargin:'0px 0px -10% 0px'});
    io.observe(native);
  }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var cv=document.querySelector('[data-da-three]');
  if(!cv||cv.__daP)return; cv.__daP=1;
  var ctx=cv.getContext&&cv.getContext('2d'); if(!ctx)return;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var w=0,h=0,dpr=Math.min(window.devicePixelRatio||1,2),parts=[],raf=0,scrollY=0,mx=0,my=0,vis=true;
  var GOLD=[ '228,203,134', '201,162,75', '246,241,231' ];

  function rnd(a,b){ return a+(b-a)*( (Math.sin((parts.length*12.9898+a*78.233+b*37.719))*43758.5453)%1+1)%1; }
  function size(){
    var r=cv.getBoundingClientRect(); w=r.width; h=r.height;
    cv.width=Math.max(1,w*dpr); cv.height=Math.max(1,h*dpr); ctx.setTransform(dpr,0,0,dpr,0,0);
    build();
  }
  function build(){
    var n=Math.max(28,Math.min(90,Math.round(w/13)));
    if(reduce) n=Math.min(n,36);
    parts=[];
    for(var i=0;i<n;i++){
      var z=0.25+Math.random()*0.9;
      parts.push({
        x:Math.random()*w, y:Math.random()*h, z:z,
        r:(0.6+Math.random()*1.8)*z,
        vy:(0.08+Math.random()*0.35)*z,
        vx:(Math.random()-0.5)*0.18*z,
        ph:Math.random()*6.28, sway:0.2+Math.random()*0.6,
        a:0.18+Math.random()*0.5,
        c:GOLD[(Math.random()*GOLD.length)|0]
      });
    }
  }
  function draw(){
    ctx.clearRect(0,0,w,h);
    var px=(mx)*14, py=(my)*14 + scrollY*0.06;
    for(var i=0;i<parts.length;i++){
      var p=parts[i];
      p.ph+=0.01;
      p.y-=p.vy; p.x+=p.vx+Math.sin(p.ph)*p.sway*0.12;
      if(p.y< -8){ p.y=h+8; p.x=Math.random()*w; }
      if(p.x< -8)p.x=w+8; else if(p.x>w+8)p.x=-8;
      var dx=p.x+px*p.z, dy=p.y+py*p.z;
      // glow tenue
      ctx.beginPath(); ctx.fillStyle='rgba('+p.c+','+(p.a*0.16)+')';
      ctx.arc(dx,dy,p.r*3.4,0,6.2832); ctx.fill();
      // núcleo
      ctx.beginPath(); ctx.fillStyle='rgba('+p.c+','+p.a+')';
      ctx.arc(dx,dy,p.r,0,6.2832); ctx.fill();
    }
  }
  function loop(){ if(vis){ draw(); } raf=requestAnimationFrame(loop); }

  size();
  if(reduce){ draw(); return; }
  window.addEventListener('resize',function(){ clearTimeout(cv.__rt); cv.__rt=setTimeout(size,180); },{passive:true});
  window.addEventListener('scroll',function(){ scrollY=window.pageYOffset||0; },{passive:true});
  window.addEventListener('mousemove',function(e){ mx=(e.clientX/window.innerWidth-0.5); my=(e.clientY/window.innerHeight-0.5); },{passive:true});
  document.addEventListener('visibilitychange',function(){ vis=!document.hidden; });
  // pausar si el hero sale de viewport
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(es){ vis=es[0].isIntersecting && !document.hidden; }).observe(cv);
  }
  loop();
})();

/* Countdown a una fecha de fin REAL (honesto). Sin fecha válida o ya vencida → el reloj se quita. */
(function(){
  var el=document.querySelector('[data-da-deadline]');
  if(!el||el.__daCD)return; el.__daCD=1;
  var wrap=el.closest('.da-hero__timer');
  var end=new Date(String(el.getAttribute('data-da-deadline')||'').trim().replace(' ','T'));
  if(isNaN(end.getTime())){ if(wrap) wrap.remove(); return; }
  function pad(n){ return (n<10?'0':'')+n; }
  function tick(){
    var d=Math.floor((end-new Date())/1000);
    if(d<=0){ if(wrap) wrap.remove(); return; }
    var dd=Math.floor(d/86400), hh=Math.floor((d%86400)/3600), mm=Math.floor((d%3600)/60), ss=d%60;
    el.textContent=(dd>0?dd+'d ':'')+pad(hh)+':'+pad(mm)+':'+pad(ss);
    if(wrap) wrap.hidden=false;
  }
  tick();
  var iv=setInterval(function(){ if(!document.body.contains(el)){clearInterval(iv);return;} tick(); },1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-faq"] && !Shopify.designMode) return;
  try {
    
// Acordeón de una sola pregunta abierta. Los navegadores modernos ya lo resuelven con el
// atributo name="" en <details>; este JS es el respaldo para navegadores que aún no lo soportan.
(function () {
  if (window.__daFaqExclusive) return; window.__daFaqExclusive = true;
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('details.da-faq__item[open]')) return;
    var group = d.closest('.da-faq__list');
    if (!group) return;
    group.querySelectorAll('details.da-faq__item[open]').forEach(function (o) {
      if (o !== d) o.open = false;
    });
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-product-conversion"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec=document.currentScript&&document.currentScript.closest?null:null;
  function fmt(c){return "$"+(c/100).toLocaleString("es-AR");}
  function upd(){
    var bars=document.querySelectorAll("[data-da-ship]");
    if(!bars.length) return;
    fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json();}).then(function(cart){
      var th=5000000, ship=1350000; // umbral envío gratis ($50.000) y costo de envío ($13.500) en centavos — mantener igual a la config de Shopify (descuento automatico "Envío gratis +$50.000")
      bars.forEach(function(box){
        var msg=box.querySelector("[data-da-ship-msg]"), bar=box.querySelector("[data-da-ship-bar]");
        var t=cart.total_price||0, pct=Math.min(100,Math.round(t/th*100));
        if(bar) bar.style.width=pct+"%";
        if(msg){
          // 3 estados: lejos/vacío → mensaje positivo (sin enmarcar la pérdida);
          // cerca (≥50%) → "te faltan X" motiva el AOV; logrado → celebra.
          var pp=parseInt(box.getAttribute("data-da-price")||"0",10);
          if(t>=th) msg.innerHTML="¡Listo! Envío <b>GRATIS</b> — te ahorrás "+fmt(ship)+" ✓";
          else if(t>0 && pct>=50) msg.innerHTML="Te faltan <b>"+fmt(th-t)+"</b> y te ahorrás <b>"+fmt(ship)+"</b> de envío";
          // carrito vacío/lejos → mensaje según el precio del propio producto (sin enmarcar la pérdida)
          else if(pp>=th) msg.innerHTML="Este perfume viaja <b>GRATIS</b> a todo el país ✓";
          else if(pp>=th/2) msg.innerHTML="¡Estás cerca! Sumá otro decant y ahorrás <b>"+fmt(ship)+"</b> de envío";
          else msg.innerHTML="Envío "+fmt(ship)+" a todo el país · <b>gratis desde "+fmt(th)+"</b>";
        }
      });
    }).catch(function(){});
  }
  if(document.readyState!=="loading")upd();else document.addEventListener("DOMContentLoaded",upd);
  document.addEventListener("cart:refresh",upd);
  document.addEventListener("shopify:section:load",upd);

  // ---- Sticky add-to-cart (mobile + desktop) ----
  function initSticky(){
    var bar=document.querySelector("[data-da-stickyatc]");
    var dataEl=document.querySelector("[data-da-product]");
    if(!bar||!dataEl) return;
    var P; try{P=JSON.parse(dataEl.textContent);}catch(e){return;}
    bar.querySelector("[data-da-sa-title]").textContent=P.title;
    var img=bar.querySelector("[data-da-sa-img]"); if(P.img){img.src=P.img;img.alt=P.title;}else img.remove();
    bar.querySelector("[data-da-sa-price]").textContent="$"+(P.price/100).toLocaleString("es-AR");
    var was=bar.querySelector("[data-da-sa-was]");
    if(P.compare&&P.compare>P.price){was.textContent="$"+(P.compare/100).toLocaleString("es-AR");}else was.remove();
    bar.hidden=false;
    // localizar form principal de add-to-cart del theme
    var mainForm=document.querySelector('form[action*="/cart/add"]');
    var buyBtn=bar.querySelector("[data-da-sa-buy]"), label=buyBtn.querySelector("span");
    if(!P.available){buyBtn.disabled=true;label.textContent="Agotado";}
    buyBtn.addEventListener("click",function(){
      if(mainForm){
        var fd=new FormData(mainForm);
        if(!fd.get("id")){var v=mainForm.querySelector('[name="id"]');}
        fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:fd})
         .then(function(r){return r.json();}).then(function(){
            buyBtn.classList.add("is-added");label.textContent="¡Agregado!";
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            setTimeout(function(){window.location.href="/cart";},800);
         }).catch(function(){ if(mainForm.requestSubmit)mainForm.requestSubmit();else mainForm.submit();});
      }
    });
    // mostrar al scrollear (cuando el form principal sale de vista, o tras 600px)
    function onScroll(){
      var show;
      if(mainForm){var r=mainForm.getBoundingClientRect();show=r.bottom<80||r.top>window.innerHeight;}
      else show=window.scrollY>600;
      bar.classList.toggle("is-show",!!show);
    }
    window.addEventListener("scroll",onScroll,{passive:true}); onScroll();
  }
  if(document.readyState!=="loading")initSticky();else document.addEventListener("DOMContentLoaded",initSticky);
})();

/* A11y: el botón sticky nativo de Horizon es solo-ícono (svg aria-hidden) → sin nombre accesible (falla WCAG button-name). Le agregamos aria-label sin tocar el componente nativo. */
(function(){
  function labelBtns(){
    document.querySelectorAll(".sticky-add-to-cart__button,.sticky-add-to-cart button.add-to-cart-button").forEach(function(b){
      var txt=(b.textContent||"").replace(/\s+/g," ").trim();
      if(!txt && !b.getAttribute("aria-label")) b.setAttribute("aria-label","Agregar al carrito");
    });
  }
  if(document.readyState!=="loading")labelBtns();else document.addEventListener("DOMContentLoaded",labelBtns);
  setTimeout(labelBtns,1500); setTimeout(labelBtns,3500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='da_rv_v1', MAX=12, SHOW=10;
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }

  document.querySelectorAll('[data-da-rv]').forEach(function(sec){
    if(sec.__rvInit)return; sec.__rvInit=1;
    var rail=sec.querySelector('[data-da-rv-rail]');
    var curEl=document.querySelector('[data-da-rv-current]');
    var current=null;
    if(curEl){ try{ current=JSON.parse(curEl.textContent); }catch(e){} }

    var list=read();
    if(current && current.handle){
      list=list.filter(function(x){return x.handle!==current.handle;});
      list.unshift(current);
      if(list.length>MAX)list=list.slice(0,MAX);
      write(list);
    }
    // riel: excluye el producto actual
    var items=list.filter(function(x){ return !current||x.handle!==current.handle; }).slice(0,SHOW);
    if(!items.length){ return; } // queda hidden

    var frag=document.createDocumentFragment();
    items.forEach(function(it){
      var a=document.createElement('a');
      a.className='da-rv__card'; a.href=it.url; a.setAttribute('role','listitem');
      a.innerHTML=
        '<span class="da-rv__thumb">'+(it.image?'<img src="'+it.image+'" alt="" loading="lazy">':'')+'</span>'+
        '<span class="da-rv__body">'+
          '<span class="da-rv__name">'+(it.title||'').replace(/</g,'&lt;')+'</span>'+
          '<span class="da-rv__meta">'+(it.vendor?(''+it.vendor).replace(/</g,'&lt;')+' · ':'')+'decant 5ml</span>'+
          (it.price?'<span class="da-rv__price">'+(''+it.price).replace(/</g,'&lt;')+'</span>':'')+
        '</span>';
      frag.appendChild(a);
    });
    rail.appendChild(frag);
    sec.hidden=false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-reviews"] && !Shopify.designMode) return;
  try {
    
// Conecta el CTA "Escribí tu reseña" con el formulario oficial de Judge.me.
// Al click busca el link de escribir del widget (.jdgm-write-rev-link) y lo dispara;
// si el widget todavía no hidrató, lleva al área de reseñas para usar su botón.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-da-write-review]');
  if (!btn) return;
  e.preventDefault();
  var sec = btn.closest('.da-rev') || document;
  var link = sec.querySelector('.jdgm-write-rev-link') || document.querySelector('.jdgm-write-rev-link');
  if (link) {
    link.click();
    link.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    var hero = document.getElementById('reviews-hero');
    if (hero) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-scent-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-da-sf]').forEach(function(root){
    if(root.__sfInit)return; root.__sfInit=1;
    var steps=[].slice.call(root.querySelectorAll('[data-da-sf-step]'));
    var dots=[].slice.call(root.querySelectorAll('[data-da-sf-dot]'));
    var result=root.querySelector('[data-da-sf-result]');
    var stage=root.querySelector('[data-da-sf-stage]');
    var backBtn=root.querySelector('[data-da-sf-back]');
    var rtitle=root.querySelector('[data-da-sf-rtitle]');
    var rsub=root.querySelector('[data-da-sf-rsub]');
    var rcta=root.querySelector('[data-da-sf-rcta]');
    var alts=root.querySelector('[data-da-sf-alts]');
    var picks=[]; var cur=0;
    var NAMES={frescos:'Frescos & Cítricos',dulces:'Dulces & Gourmand',amaderados:'Amaderados',especiados:'Especiados & Orientales',frutales:'Frutales',nocturnos:'Nocturnos',recomendados:'Más Buscados',elegantes:'Elegantes',seductores:'Seductores',intensos:'Intensos'};

    function show(i){
      steps.forEach(function(s,k){s.classList.toggle('is-active',k===i);});
      dots.forEach(function(d,k){d.classList.toggle('is-on',k<=i);});
      backBtn.hidden = i===0;
      cur=i;
    }
    function reset(){
      picks=[]; result.hidden=true; stage.scrollIntoView({behavior:'smooth',block:'nearest'});
      root.querySelectorAll('.da-sf__opt').forEach(function(b){b.classList.remove('is-picked');});
      steps.forEach(function(s){s.style.display='';});
      show(0);
    }
    function finish(){
      // puntaje: familia (data-w=2) domina; carácter/momento suman 1
      var score={},label={};
      picks.forEach(function(p){
        score[p.col]=(score[p.col]||0)+p.w;
        label[p.col]=p.label;
      });
      var order=Object.keys(score).sort(function(a,b){return score[b]-score[a];});
      var win=order[0];
      var winName=NAMES[win]||win;
      rtitle.textContent=winName;
      // arma frase con las elecciones reales
      var chosen=picks.map(function(p){return p.label;});
      rsub.textContent='Elegiste '+chosen[0]+', perfil '+chosen[1]+' y '+chosen[2]+'. Tu mejor punto de partida es la familia '+winName+'.';
      rcta.setAttribute('href','/collections/'+win);
      rcta.firstChild&&(rcta.textContent='Ver '+winName+' →');
      // alternativas = el resto de colecciones elegidas, distintas a la ganadora
      alts.innerHTML='';
      var seen={}; seen[win]=1;
      order.slice(1).concat(['mas-vendidos','sets-y-combos']).forEach(function(c){
        if(seen[c])return; seen[c]=1;
        var a=document.createElement('a');
        a.href='/collections/'+c; a.textContent=NAMES[c]||(c==='sets-y-combos'?'Sets y Combos':c==='mas-vendidos'?'Más Vendidos':c);
        alts.appendChild(a);
      });
      steps.forEach(function(s){s.style.display='none';});
      dots.forEach(function(d){d.classList.add('is-on');});
      result.hidden=false; backBtn.hidden=true;
      // --- Klaviyo: perfil olfativo (familia preferida = oro para segmentar campañas) ---
      try{
        var prof={
          familia_preferida: win,
          familia_preferida_nombre: winName,
          perfil_momento: (picks[0]&&picks[0].label)||'',
          perfil_familia: (picks[1]&&picks[1].label)||'',
          perfil_caracter: (picks[2]&&picks[2].label)||'',
          perfil_olfativo_fecha: new Date().toISOString()
        };
        try{ localStorage.setItem('da_sf_profile', JSON.stringify(prof)); }catch(e){}
        var kl = window.klaviyo || (window.klaviyo = []);
        kl.push(['track','Perfil Olfativo Completado', prof]);
        var ident = {
          familia_preferida: winName,
          familia_preferida_handle: win,
          perfil_olfativo_fecha: prof.perfil_olfativo_fecha
        };
        var ce = root.getAttribute('data-customer-email'); if(ce){ ident['$email'] = ce; }
        kl.push(['identify', ident]);
      }catch(e){}
      result.scrollIntoView({behavior:'smooth',block:'center'});
    }

    steps.forEach(function(step,i){
      step.querySelectorAll('.da-sf__opt').forEach(function(btn){
        btn.addEventListener('click',function(){
          step.querySelectorAll('.da-sf__opt').forEach(function(b){b.classList.remove('is-picked');});
          btn.classList.add('is-picked');
          picks[i]={col:btn.dataset.col,w:parseInt(btn.dataset.w||'1',10),label:btn.dataset.label};
          setTimeout(function(){ i<steps.length-1 ? show(i+1) : finish(); },230);
        });
      });
    });
    backBtn.addEventListener('click',function(){ if(cur>0)show(cur-1); });
    root.querySelector('[data-da-sf-restart]').addEventListener('click',reset);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-search-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-da-predictive]').forEach(function(box){
    if(box.__pInit)return; box.__pInit=1;
    var input=box.querySelector('[data-da-input]');
    var panel=box.querySelector('[data-da-panel]');
    var list=box.querySelector('[data-da-list]');
    var allLink=box.querySelector('[data-da-all]');
    var allTxt=box.querySelector('[data-da-all-txt]');
    if(!input||!panel)return;
    var timer=null, ctrl=null, items=[], active=-1, lastQ='';

    function money(v){
      var n=parseFloat(v); if(isNaN(n))return '';
      // suggest.json devuelve precio en unidad mayor (ARS). Sin centavos.
      return '$'+Math.round(n).toLocaleString('es-AR');
    }
    function thumb(p){
      var u=(p.featured_image&&p.featured_image.url)||p.image||'';
      if(!u)return '';
      return u.indexOf('?')>-1 ? u+'&width=92' : u+'?width=92';
    }
    function close(){
      panel.hidden=true; input.setAttribute('aria-expanded','false');
      input.removeAttribute('aria-activedescendant'); active=-1;
    }
    function open(){
      if(panel.hidden){panel.hidden=false; input.setAttribute('aria-expanded','true');}
    }
    function setActive(i){
      var opts=panel.querySelectorAll('[role="option"]');
      opts.forEach(function(o){o.classList.remove('is-active');});
      active=i;
      if(i>=0&&opts[i]){opts[i].classList.add('is-active'); input.setAttribute('aria-activedescendant',opts[i].id); opts[i].scrollIntoView({block:'nearest'});}
      else input.removeAttribute('aria-activedescendant');
    }
    function render(products,q){
      list.innerHTML=''; items=products;
      if(!products.length){
        list.innerHTML='<li class="da-srch__empty">Sin coincidencias para “'+q.replace(/</g,'&lt;')+'”. Probá una marca (Dior, Lattafa…).</li>';
      } else {
        products.forEach(function(p,i){
          var li=document.createElement('li');
          var a=document.createElement('a');
          a.className='da-srch__opt'; a.href=p.url; a.id='da-srch-opt-'+i; a.setAttribute('role','option');
          var im=thumb(p);
          a.innerHTML=(im?'<img src="'+im+'" alt="" loading="lazy" width="46" height="46">':'')+
            '<span class="da-srch__opt-info"><span class="da-srch__opt-title">'+(p.title||'').replace(/</g,'&lt;')+'</span>'+
            (p.vendor?'<span class="da-srch__opt-meta">'+(''+p.vendor).replace(/</g,'&lt;')+' · decant 5ml</span>':'<span class="da-srch__opt-meta">decant 5ml</span>')+'</span>'+
            '<span class="da-srch__opt-price">'+money(p.price)+'</span>';
          a.addEventListener('mouseenter',function(){setActive(i);});
          li.appendChild(a); list.appendChild(li);
        });
      }
      allTxt.textContent='Ver todos los resultados de “'+q+'”';
      allLink.href='/search?q='+encodeURIComponent(q);
      setActive(-1); open();
    }
    function fetchSuggest(q){
      if(ctrl)ctrl.abort();
      ctrl=new AbortController();
      var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url,{signal:ctrl.signal,headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(d){
          var prods=(((d||{}).resources||{}).results||{}).products||[];
          if(input.value.trim()===q) render(prods,q);
        }).catch(function(){});
    }
    input.addEventListener('input',function(){
      var q=input.value.trim();
      if(q===lastQ)return; lastQ=q;
      clearTimeout(timer);
      if(q.length<2){close();return;}
      timer=setTimeout(function(){fetchSuggest(q);},170);
    });
    input.addEventListener('focus',function(){ if(input.value.trim().length>=2&&list.children.length)open(); });
    input.addEventListener('keydown',function(e){
      var opts=panel.hidden?[]:panel.querySelectorAll('[role="option"]');
      if(e.key==='ArrowDown'){ if(panel.hidden)return; e.preventDefault(); setActive(Math.min(active+1,opts.length-1)); }
      else if(e.key==='ArrowUp'){ if(panel.hidden)return; e.preventDefault(); setActive(Math.max(active-1,-1)); }
      else if(e.key==='Enter'){ if(active>=0&&opts[active]){ e.preventDefault(); window.location.href=opts[active].href; } }
      else if(e.key==='Escape'){ close(); }
    });
    document.addEventListener('click',function(e){ if(!box.contains(e.target))close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-share"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sec=document.querySelector('[data-da-share]');
  if(!sec||sec.__shInit)return; sec.__shInit=1;
  var url=sec.getAttribute('data-share-url');
  var title=sec.getAttribute('data-share-title');
  var copyBtn=sec.querySelector('[data-da-share-copy]');
  var copyLabel=sec.querySelector('[data-da-share-copylabel]');
  var nativeBtn=sec.querySelector('[data-da-share-native]');

  if(copyBtn){
    copyBtn.addEventListener('click',function(){
      var done=function(){
        copyBtn.classList.add('is-done');
        if(copyLabel) copyLabel.textContent='¡Link copiado!';
        setTimeout(function(){ copyBtn.classList.remove('is-done'); if(copyLabel) copyLabel.textContent='Copiar link'; },1900);
      };
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(done).catch(done); }
      else { try{ var t=document.createElement('textarea'); t.value=url; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t); done(); }catch(e){} }
    });
  }
  if(nativeBtn && navigator.share){
    nativeBtn.hidden=false;
    nativeBtn.addEventListener('click',function(){
      navigator.share({title:title,text:'Mirá este decant: '+title,url:url}).catch(function(){});
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-wishlist"] && !Shopify.designMode) return;
  try {
    
(function(){
  var KEY='da_fav_v1';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function esc(s){ return (''+(s||'')).replace(/</g,'&lt;'); }

  var sec=document.querySelector('[data-da-wish]');
  var rail=sec&&sec.querySelector('[data-da-wish-rail]');
  var countEl=sec&&sec.querySelector('[data-da-wish-count]');
  var clearBtn=sec&&sec.querySelector('[data-da-wish-clear]');
  var toggle=document.querySelector('[data-da-wish-toggle]');
  var curEl=document.querySelector('[data-da-wish-current]');
  var current=null;
  if(curEl){ try{ current=JSON.parse(curEl.textContent); }catch(e){} }

  function isFav(h){ return read().some(function(x){return x.handle===h;}); }

  function renderRail(){
    if(!sec||!rail)return;
    var favs=read();
    rail.innerHTML='';
    if(!favs.length){ sec.hidden=true; return; }
    if(countEl) countEl.textContent='· '+favs.length+(favs.length===1?' guardado':' guardados');
    favs.forEach(function(it){
      var card=document.createElement('div');
      card.className='da-wish__card'; card.setAttribute('role','listitem');
      card.innerHTML=
        '<a class="da-wish__card-link" href="'+it.url+'">'+
          '<span class="da-wish__thumb">'+(it.image?'<img src="'+it.image+'" alt="" loading="lazy">':'')+'</span>'+
          '<span class="da-wish__body">'+
            '<span class="da-wish__name">'+esc(it.title)+'</span>'+
            '<span class="da-wish__meta">'+(it.vendor?esc(it.vendor)+' · ':'')+'decant 5ml</span>'+
            (it.price?'<span class="da-wish__price">'+esc(it.price)+'</span>':'')+
          '</span>'+
        '</a>'+
        '<button type="button" class="da-wish__rm" aria-label="Quitar '+esc(it.title)+' de favoritos" data-rm="'+esc(it.handle)+'">×</button>';
      rail.appendChild(card);
    });
    sec.hidden=false;
  }

  function syncToggle(){
    if(!toggle||!current)return;
    var on=isFav(current.handle);
    toggle.setAttribute('aria-pressed', on?'true':'false');
    var lbl=toggle.querySelector('[data-da-wish-label]');
    if(lbl) lbl.textContent= on?'Guardado en favoritos':'Guardar en favoritos';
  }

  if(toggle&&current){
    toggle.addEventListener('click',function(){
      var favs=read();
      if(isFav(current.handle)){
        favs=favs.filter(function(x){return x.handle!==current.handle;});
      } else {
        favs.unshift(current);
        toggle.classList.add('is-bump');
        setTimeout(function(){toggle.classList.remove('is-bump');},320);
      }
      write(favs); syncToggle(); renderRail();
      window.dispatchEvent(new Event('da-fav-changed'));
    });
    syncToggle();
  }
  if(rail){
    rail.addEventListener('click',function(e){
      var btn=e.target.closest('[data-rm]'); if(!btn)return;
      e.preventDefault();
      write(read().filter(function(x){return x.handle!==btn.getAttribute('data-rm');}));
      syncToggle(); renderRail();
      window.dispatchEvent(new Event('da-fav-changed'));
    });
  }
  if(clearBtn){ clearBtn.addEventListener('click',function(){ write([]); syncToggle(); renderRail(); window.dispatchEvent(new Event('da-fav-changed')); }); }
  renderRail();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
